import Tippy from '@tippyjs/react';
import Input from '../Input';
import bem from '../../../../utils/bem';

const CheckboxButton = ({
  id = 'checkbox',
  value,
  name,
  children = 'Get an Estimate',
  disabled,
  tooltip,
  onChange,
  isSelected,
  inputExtra,
  inputOnClick,
  modalId,
  withoutBorder,
}) => {
  const baseClass = 'form-checkbox-button';

  const onChangeHandler = () => {
    onChange(!isSelected);
  };

  const enableTooltip = !!(tooltip && disabled);

  const renderComponent = (
    <div
      className={bem(
        baseClass,
        [
          disabled ? 'disabled' : '',
          isSelected ? 'checked' : '',
          withoutBorder ? '' : 'with-border',
        ],
        '',
        ['form-item'],
      )}
    >
      <Input
        id={id}
        value={value}
        name={id}
        onChange={onChangeHandler}
        base={baseClass}
        disabled={disabled}
        data-name={name}
        children={children}
        extraLabel={'option'}
        checked={isSelected}
        data-modal-id={modalId}
        extraInput={inputExtra}
        onClick={inputOnClick}
      />
    </div>
  );

  return enableTooltip ? (
    <Tippy content={tooltip} maxWidth={200} hideOnClick={true} trigger="click">
      {renderComponent}
    </Tippy>
  ) : (
    renderComponent
  );
};

export default CheckboxButton;
